import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import type { MenuItem } from 'primevue/menuitem';

export const useAppMenuItemsStore = defineStore('app-menu-items', () => {
    const items = ref<MenuItem[]>([]);

    const hasItems = computed(() => items.value.length > 0);

    const activeItem = ref<string | null>(null);

    const hasActiveItem = computed(() => activeItem.value !== null);

    function clearActiveItem() {
        activeItem.value = null;
    }

    return {
        items,
        hasItems,
        activeItem,
        hasActiveItem,
        clearActiveItem,
    };
});
